import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MediaComponent } from './media.component';
import { MediaBodyComponent } from './components/body.component';
import { MediaLeftComponent } from './components/left.component';
import { MediaRightComponent } from './components/right.component';

export { MediaComponent } from './media.component';
export { MediaBodyComponent } from './components/body.component';
export { MediaLeftComponent } from './components/left.component';
export { MediaRightComponent } from './components/right.component';

@NgModule({
  declarations: [
    MediaComponent,
    MediaBodyComponent,
    MediaLeftComponent,
    MediaRightComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    MediaComponent,
    MediaBodyComponent,
    MediaLeftComponent,
    MediaRightComponent
  ],
  providers: [],
})
export class MediaModule {}
